import HeaderContent from "@shared/ui/header-content/header-content";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useListCardsContext } from "../list-cards/list-cards.context";
import TextBlock from "@shared/ui/text-block/text-block";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

export function CardSettings() {
  const navigate = useNavigate();
  const { formatDate } = useDateTimeContext();

  const { selectedCard } = useListCardsContext();
  return (
    <div id="CardSettings" className="customer">
      <HeaderContent
        title={<h1>Card Settings</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("..")}
      >
        <div className="grid grid-cols-2 gap-2"></div>
      </HeaderContent>
      <div className="bg-white p-7">
        <TextBlock
          label="Activation Date"
          value={formatDate(selectedCard?.activation_date)}
        />
        <TextBlock
          label="Expiration Date"
          value={formatDate(selectedCard?.expiration_date)}
        />
        <TextBlock
          label="Cardholder Name"
          value={(selectedCard as any)?.card_owner_first_name}
        />
        <TextBlock label="Level Points Cap" value={"TODO"} />
        <TextBlock label="Level Stamps Cap" value={"TODO"} />
      </div>
    </div>
  );
}

export default CardSettings;
